import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	logo: {
		maxHeight: 40,
		maxWidth: 200,
		width: '100%',
	},
	logoCompact: {
		height: 28,
		width: 28,
	},
	searchButton: {
		appearance: 'none',
		background: 'none',
		border: 'none',
		cursor: 'pointer',
		font: 'inherit',
	},
});
